const CYRILLIC_TRANSLITERATION: Record<string, string> = {
  а: "a",
  б: "b",
  в: "v",
  г: "g",
  д: "d",
  е: "e",
  ё: "e",
  ж: "zh",
  з: "z",
  и: "i",
  й: "y",
  к: "k",
  л: "l",
  м: "m",
  н: "n",
  о: "o",
  п: "p",
  р: "r",
  с: "s",
  т: "t",
  у: "u",
  ф: "f",
  х: "kh",
  ц: "ts",
  ч: "ch",
  ш: "sh",
  щ: "shch",
  ъ: "",
  ы: "y",
  ь: "",
  э: "e",
  ю: "yu",
  я: "ya",
};

/** Cyrillic → Latin transliteration using a fixed phonetic map (same scheme as speaker email slugs). */
export const transliterateCyrillicToLatin = (value: string): string =>
  Array.from(value.toLowerCase())
    .map((char) => CYRILLIC_TRANSLITERATION[char] ?? char)
    .join("");
